import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { Router } from '@angular/router';
import { Route } from '../../interfaces/route';
import { RouteService } from '../../services/route.service';
import { RouteDirectionsService } from '../../services/route-directions.service';
import { StopsService } from '../../services/stops.service';
import { ScheduleService } from '../../services/schedule.service';
import { MapService } from '../../services/map.service';
import { MarkersService } from '../../services/markers.service';
import { ScheduleRouteTodayComponent } from "../schedule-route-today/schedule-route-today.component";
import { GlobalVariables } from "../../common/global-variables";


const rail_routes: any = Array("AIR", "CHE", "CHW", "LAN", "MED", "FOX", "NOR", "PAO", "CYN", "TRE", "WAR", "WIL", "WTR", "GC");


@Component({
  selector: 'app-schedule-route-details',
  templateUrl: './schedule-route-details.component.html',
  styleUrls: ['./schedule-route-details.component.css']
})
export class ScheduleRouteDetailsComponent implements OnInit {

  @ViewChild(ScheduleRouteTodayComponent) today_component;

  public recent_routes: any = [];
  public recent_routes_max_length = GlobalVariables.max_recent_routes;
  public routes: Route[] = [];
  public calendar: any;
  private id: string;
  public selected_date: any;
  public selected_direction: string = "0";
  public selected_stop: string;
  public realtime: boolean = true;
  public stops: any;
  public stop_times: any;
  public mode: string = 'bus';
  public detailedRoute: any = { id: '' };
  public directions: any = [{ Direction: 0, DirectionDescription: 'Inbound' }, { Direction: 1, DirectionDescription: 'Outbound' }];
  public pdfUrl: string = GlobalVariables.pdfScheduleUrl;
  public scheduledPdf: any = []

  constructor(private routeService: RouteService, private route: ActivatedRoute, private mapService: MapService, private markersService: MarkersService, private routeDirectionsService: RouteDirectionsService, private stopsService: StopsService, private scheduleService: ScheduleService, private router: Router) {

    var recent_routes = localStorage.getItem("recent_routes");

    if (recent_routes != null) {

      if (Array.isArray(JSON.parse(recent_routes)) === true) {
        this.recent_routes = JSON.parse(recent_routes);
      }
      else {
        this.recent_routes.push(recent_routes)
      }

    }

    this.calendar = this.scheduleService.get_calendar()
      .subscribe(calendar => {

        this.selected_date = this.scheduleService.get_date();

        this.calendar = calendar[this.selected_date]['week_schedule'];

      });

    this.detailedRoute = this.routeService.detailed;
    this.getRoutes();

    this.id = this.route.snapshot.paramMap.get('route');
    this.pdfUrl = this.pdfUrl + this.id + '.pdf'
    this.selected_direction = this.route.snapshot.paramMap.get('direction');
    this.selected_stop = this.route.snapshot.paramMap.get('stop');

    this.scheduleService.get_pdf_schedule(this.id)
    .subscribe(schedules => {
      this.scheduledPdf = schedules;
    });

    //If route is selected, load the directions into the button, default to zero, load the stops for zero...
    if (this.id != "") {
      if (rail_routes.includes(this.id)) {
        this.mode = 'rail'
      }

      //Check if newly selected route is in the recent selected routes, if not add it...
      if (this.recent_routes.find((x: string) => x == this.id) == undefined) {
        this.recent_routes.push(this.id);

        //Check if recent routes is larger than set limit
        if (this.recent_routes.length > this.recent_routes_max_length) {
          this.recent_routes.shift();
        }

        localStorage.setItem("recent_routes", JSON.stringify(this.recent_routes));
      }
    }

    this.routeDirectionsService.get(this.id)
      .subscribe(routes => {
        this.directions = routes;

        var directions_len = Object.keys(this.directions).length;

        if(directions_len <= 1){
          this.selected_direction = this.directions[0].Direction;
        }
        else if(this.route.snapshot.paramMap.get('direction') == undefined){
          this.selected_direction = this.selected_direction = this.directions[0].Direction;
        }
        else{
          this.selected_direction = this.route.snapshot.paramMap.get('direction');
        }

        this.stopsService.getStops(this.id, parseInt(this.selected_direction))
          .subscribe(stops => {
            this.stops = stops;

          });

      });

    this.stopsService.getStops(this.id, parseInt(this.selected_direction))

    if (this.id != null && this.selected_stop != null && this.selected_stop != "") {
      //call stoptimes api
      this.stopsService.getStopTimes(this.id, parseInt(this.selected_direction), this.selected_stop)
        .subscribe(stop_times => this.stop_times = stop_times);
    }
  }

  ngOnInit(): void {
    this.getRoutes();
    this.detailedRoute.id = this.routeService.detailed.id

    if (this.id != null) {
      this.detailedRoute = { id: this.id };
    }
    else {
      this.detailedRoute.id = this.routeService.detailed.id
    }
  }

  ngAfterViewInit(): void {
    this.markersService.addStopMarkers(this.mapService.map, this.id, Number(this.selected_direction), Number(this.selected_stop));
  }

  getRoutes(): void {
    this.routeService.get()
      .subscribe(routes => {
        this.routes = routes;
        this.realtime = this.routeService.realtime;
      });
  }

  //On select of the direction
  onDirectionChange(direction: string): void {
    this.router.navigateByUrl('schedules/' + this.id + '/' + direction);
    this.selected_direction = direction;

    this.markersService.clearStopMarkers(this.mapService.map);

    this.markersService.addStopMarkers(this.mapService.map, this.id, Number(this.selected_direction), Number(this.selected_stop));

    this.stopsService.getStops(this.id, parseInt(this.selected_direction))
      .subscribe(stops => this.stops = stops);
  }

  //On select of stop
  onStopChange(stop: string): void {
    this.router.navigateByUrl('schedules/' + this.id + '/' + this.selected_direction + '/' + stop);
    this.selected_stop = stop;

    if (this.id != null && this.selected_stop != null) {
      //call stoptimes api
      this.stopsService.getStopTimes(this.id, parseInt(this.selected_direction), this.selected_stop)
        .subscribe(stop_times => this.stop_times = stop_times);

      this.today_component.selected_direction = this.selected_direction;
      this.today_component.selected_stop = this.selected_stop;
      this.today_component.refresh();
    }

  }

}